<template>
  <div>
    <van-tabbar
      route
      active-color="#0BC94E"
      inactive-color="#333333"
      z-index="997"
      :placeholder="true"
    >
      <van-tabbar-item replace to="/local/home">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? homeIcon.active : homeIcon.inactive" />
            <span class="f24 mtop8">首页</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/local/map-goods">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? mapIcon.active : mapIcon.inactive" />
            <span class="f24 mtop8">地图</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/local/member">
        <template #icon="props">
          <div class="flexbox_column hcenter" style="position: relative">
            <img
              :src="props.active ? memberIcon.active : memberIcon.inactive"
            />
            <span class="f24 mtop8">会员</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/local/activities" :badge="paidNum">
        <template #icon="props">
          <div class="flexbox_column hcenter" style="position: relative">
            <img
              :src="props.active ? activityIcon.active : activityIcon.inactive"
            />

            <span class="f24 mtop8">活动</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace to="/local/mine">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? mineIcon.active : mineIcon.inactive" />
            <span class="f24 mtop8">我的</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import {
  getStorage,
  setAppIdStorage,
  getAppIdStorage,
  setLocalStorageAndTime,
} from "@/libs/storage"
import { getcoordinateApi } from "@/utils/user"
import { mapState } from "vuex"
const wx = require("weixin-js-sdk")
export default {
  data() {
    return {
      showShare: false,
      active: 0,
      value: "",
      homeIcon: {
        active: require("@/assets/images/local-product/home-selected.png"),
        inactive: require("@/assets/images/local-product/home.png"),
      },
      mapIcon: {
        active: require("@/assets/images/local-product/map-selected.png"),
        inactive: require("@/assets/images/local-product/map.png"),
      },
      memberIcon: {
        active: require("@/assets/images/local-product/member-selected.png"),
        inactive: require("@/assets/images/local-product/member.png"),
      },
      activityIcon: {
        active: require("@/assets/images/local-product/activity-selected.png"),
        inactive: require("@/assets/images/local-product/activity.png"),
      },
      mineIcon: {
        active: require("@/assets/images/local-product/mine-selected.png"),
        inactive: require("@/assets/images/local-product/mine.png"),
      },
      selectCity: null,
      paidNum: "",
      infos_storage: null,
      appId: "",
      environment: "",
    }
  },
  computed: {
    ...mapState(["cachedViews"]),
  },
  created() {
    this.appId = getStorage("appId")
    this.environment = getStorage("environment")
    this.infos_storage = getAppIdStorage(this.appId) || {}
    this.appId = this.infos_storage.userInfo.appId
  },

  mounted() {
    this.$store.commit("showBack", "true")
  },

  methods: {
    goTo() {
      window.location.href = "/local/member"
    },

    share() {
      let environment = getStorage("environment")
      if (environment === "weixin") {
        let url = ""
        if (this.appId === "wx51103d007a84d074") {
          //乘车码小程序appid
          url = `/advertPages/web-view/interactive?type=share&shareType=welfare`
        } else {
          url = `/pages/webview/interactive?type=share&shareType=welfare`
        }

        wx.miniProgram.navigateTo({
          url: url,
        })
      } else {
        this.showShare = true
      }
    },
    goSelectCity() {
      window.location.href = "/select-city"
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .van-search {
  padding: 0 10px;
}
::v-deep .van-search__content {
  width: 100%;
  background: #ffffff;
  padding: 0;
}
.num {
  background: red;
  color: #fff;
  width: 13px;
  height: 13px;
  line-height: 13px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -7px;
  font-size: 12px;
}
</style>
